module.exports = __webpack_public_path__ + "static/Stirge-62bc1b6dee385dc749656392e4a253b0.jpg";